import { Col, Form, InputNumber, Modal, Space, notification, Row } from 'antd';
import CustomButton from 'components/custom-button';
import { useEffect, useState } from 'react';
import { API } from 'service/api-route';
import AxiosUtils from 'utils/axios-utils';
import { REQUIRED } from 'constants/rule-form';

interface Props {
  isOpen: boolean;
  handleCancel: () => void;
  onUpdated: () => void;
  valueSelected: any;
}

const ModalUpdatePayslip = ({ isOpen, handleCancel, onUpdated, valueSelected }: Props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (valueSelected) {
      form.setFieldsValue({
        allowanceFixed: valueSelected?.allowanceFixed ?? 0,
        attendanceAllowance: valueSelected?.attendanceAllowance ?? 0,
        baseSalaryActual: valueSelected?.baseSalaryActual ?? 0,
        overtimeSalary: valueSelected?.overtimeSalary ?? 0,
        bonus: valueSelected?.bonus ?? 0,
        kpiIncome: valueSelected?.kpiIncome ?? 0,
        advance: valueSelected?.advance ?? 0,
        bhxh: valueSelected?.bhxh ?? 0,
        fine: valueSelected?.fine ?? 0,
        otherDeduction: valueSelected?.otherDeduction ?? 0,
        workingDays: valueSelected?.workingDays ?? 0,
        workingHours: valueSelected?.workingHours ?? 0,
      });
    }
  }, [form, valueSelected]);

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      await AxiosUtils.patch(`${API.payslips}/${valueSelected?.id}`, values);
      notification.success({ message: 'Cập nhật phiếu lương thành công' });
      onUpdated();
      handleCancel();
    } catch (e: any) {
      notification.error({ message: e?.message || 'Cập nhật thất bại' });
    } finally {
      setLoading(false);
    }
  };

  const numberFormatter = (value: any) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const numberParser = (value: any) => value!.replace(/\$\s?|(,*)/g, '');

  return (
    <Modal
      forceRender
      open={isOpen}
      title={'Cập nhật phiếu lương'}
      onCancel={handleCancel}
      width={800}
      getContainer={false}
      footer={false}
    >
      <Form
        name="form"
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={onFinish}
      >
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <label>Lương cơ bản</label>
            <Form.Item name="baseSalaryActual" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber
                formatter={numberFormatter}
                parser={numberParser}
                placeholder="Lương cơ bản"
                size="large"
                style={{ width: '100%' }}
                min={0}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <label>Lương OT</label>
            <Form.Item name="overtimeSalary" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber
                formatter={numberFormatter}
                parser={numberParser}
                placeholder="Lương OT"
                size="large"
                style={{ width: '100%' }}
                min={0}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <label>Phụ cấp cố định</label>
            <Form.Item name="allowanceFixed" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber
                formatter={numberFormatter}
                parser={numberParser}
                placeholder="Phụ cấp cố định"
                size="large"
                style={{ width: '100%' }}
                min={0}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <label>Phụ cấp chuyên cần</label>
            <Form.Item name="attendanceAllowance" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber
                formatter={numberFormatter}
                parser={numberParser}
                placeholder="Phụ cấp chuyên cần"
                size="large"
                style={{ width: '100%' }}
                min={0}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <label>Thưởng</label>
            <Form.Item name="bonus" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber
                formatter={numberFormatter}
                parser={numberParser}
                placeholder="Thưởng"
                size="large"
                style={{ width: '100%' }}
                min={0}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <label>Thu nhập KPI</label>
            <Form.Item name="kpiIncome" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber
                formatter={numberFormatter}
                parser={numberParser}
                placeholder="Thu nhập KPI"
                size="large"
                style={{ width: '100%' }}
                min={0}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <label>Tạm ứng</label>
            <Form.Item name="advance" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber
                formatter={numberFormatter}
                parser={numberParser}
                placeholder="Tạm ứng"
                size="large"
                style={{ width: '100%' }}
                min={0}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <label>BHXH</label>
            <Form.Item name="bhxh" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber
                formatter={numberFormatter}
                parser={numberParser}
                placeholder="BHXH"
                size="large"
                style={{ width: '100%' }}
                min={0}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <label>Phạt</label>
            <Form.Item name="fine" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber
                formatter={numberFormatter}
                parser={numberParser}
                placeholder="Phạt"
                size="large"
                style={{ width: '100%' }}
                min={0}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <label>Khấu trừ khác</label>
            <Form.Item name="otherDeduction" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber
                formatter={numberFormatter}
                parser={numberParser}
                placeholder="Khấu trừ khác"
                size="large"
                style={{ width: '100%' }}
                min={0}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col span={12}>
            <label>Ngày công</label>
            <Form.Item name="workingDays" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber placeholder="Ngày công" size="large" style={{ width: '100%' }} min={0} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <label>Giờ công</label>
            <Form.Item name="workingHours" rules={[REQUIRED]} wrapperCol={{ span: 24 }}>
              <InputNumber placeholder="Giờ công" size="large" style={{ width: '100%' }} min={0} />
            </Form.Item>
          </Col>
        </Row>

        <div className="d-flex justify-center">
          <Space size="large">
            <CustomButton
              bgColor="secondary-green"
              text="Lưu"
              htmlType="submit"
              loading={loading}
            />
            <CustomButton
              text="Hủy Bỏ"
              bgColor="primary-grey"
              htmlType="button"
              onClick={handleCancel}
            />
          </Space>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalUpdatePayslip;
